import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'admissions-engagements-tab-2-part',
	standalone: true,
	templateUrl: './admissions-engagements-tab-2.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./admissions-engagements-tab-2.part.scss`],
})
export class AdmissionsEngagementsTab2Part {
}
